/**
 * ensureAbsoluteUrl function.
 * Ensure URL has a protocol (http:// or https://).
 * @param {string} url - The URL to validate
 * @returns {string} - URL with protocol
 */
const ensureAbsoluteUrl = (url) => {
  if (!url) return '';

  // Check if URL already has a protocol
  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  // Check if URL starts with '//' (protocol-relative URL)
  if (url.startsWith('//')) {
    return `https:${url}`;
  }

  // Default to https:// for URLs without protocol
  return `https://${url}`;
};

/**
 * isSafeUrl function.
 * Validate that a URL uses a safe protocol (http or https).
 * @param {string} url - The URL to validate
 * @returns {boolean} - Whether the URL is safe
 */
const isSafeUrl = (url) => {
  try {
    const { protocol } = new URL(url);
    return protocol === 'https:' || protocol === 'http:';
  } catch {
    return false;
  }
};

export { isSafeUrl };
export default ensureAbsoluteUrl;
